import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { PaymentMethod } from "../../../../shared/components/Widget/types/Enums";
import { API_URL } from "../../../../shared/components/Widget/config/api";
import { ANONYMOUS_DONOR } from "../../../../shared/components/Widget/config/anonymous-donor";
import { FormData } from "./useFundraiserForm";
import { paymentMethodMap } from "../../../../shared/components/Widget/components/panes/DonorPane/DonorPane";
import { getReferralCodeFromLocation, getStoredReferralCode } from "../../../../../util/referralCode";
interface UseRegisterDonationProps {
  fundraiserId: string;
  organizationInfo: {
    databaseIds: {
      causeAreaId: number;
      organizationId: number;
    };
  };
  paymentMethods: Array<{
    _id?: string;
    _type: string;
  }>;
  onSuccess: (kid: string) => void;
}
export function useRegisterDonation(t0) {
  const $ = _c(9);
  const {
    fundraiserId,
    organizationInfo,
    paymentMethods,
    onSuccess
  } = t0;
  const [loading, setLoading] = useState(false);
  const [kid, setKid] = useState(null);
  let t1;
  if ($[0] !== fundraiserId || $[1] !== onSuccess || $[2] !== organizationInfo || $[3] !== paymentMethods) {
    t1 = formData => {
      setLoading(true);
      const selectedPaymentMethod = paymentMethods.find(method => method._id === formData.paymentMethod || method._type === formData.paymentMethod);
      const paymentMethodId = selectedPaymentMethod?._id || selectedPaymentMethod?._type || formData.paymentMethod;
      const method_0 = paymentMethodMap[paymentMethodId] || PaymentMethod.BANK;
      const referralCode = getReferralCodeFromLocation() ?? getStoredReferralCode();
      fetch(`${API_URL}/donations/register`, {
        headers: {
          accept: "application/json",
          "content-type": "application/json"
        },
        body: JSON.stringify({
          distributionCauseAreas: [{
            id: organizationInfo.databaseIds.causeAreaId,
            percentageShare: "100",
            standardSplit: false,
            amount: formData.amount,
            organizations: [{
              id: organizationInfo.databaseIds.organizationId,
              percentageShare: "100",
              amount: formData.amount
            }]
          }],
          donor: !formData.email ? ANONYMOUS_DONOR : {
            name: formData.messageSenderName,
            email: formData.email,
            taxDeduction: formData.taxDeduction,
            ssn: formData.ssn,
            newsletter: formData.newsletter
          },
          fundraiser: {
            id: fundraiserId,
            message: formData.message,
            messageSenderName: formData.messageSenderName ? formData.messageSenderName : null,
            showName: formData.messageSenderName ? formData.showName : false
          },
          method: method_0,
          amount: formData.amount,
          recurring: formData.recurring,
          ...(referralCode ? {
            referralCode
          } : {})
        }),
        method: "POST"
      }).then(_temp).then(data => {
        if (data.status !== 200) {
          console.error("Error:", data.content);
          setLoading(false);
          return;
        }
        const receivedKid = data.content.KID;
        setKid(receivedKid);
        if (data.content.paymentProviderUrl && data.content.paymentProviderUrl.length > 0) {
          window.open(data.content.paymentProviderUrl, "_self");
        } else {
          onSuccess(receivedKid);
          setLoading(false);
        }
      }).catch(error => {
        console.error("Error:", error);
        setLoading(false);
      });
    };
    $[0] = fundraiserId;
    $[1] = onSuccess;
    $[2] = organizationInfo;
    $[3] = paymentMethods;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const registerDonation = t1;
  let t2;
  if ($[5] !== kid || $[6] !== loading || $[7] !== registerDonation) {
    t2 = {
      registerDonation,
      loading,
      kid
    };
    $[5] = kid;
    $[6] = loading;
    $[7] = registerDonation;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
}
function _temp(res) {
  return res.json();
}